import { t } from 'ttag'
import styled from 'styled-components'
import { useMutation } from 'react-query'
import { useState } from 'react'

import { Flex } from '@h2/components/layout/flex'
import { Text } from '@h2/components/typography/text'
import { Button } from '@h2/components/buttons/button'
import { api } from '@h2/api'
import { Alert } from '@h2/components/display/alert'
import { Link } from '@h2/common/components/link'
import { useNavigator } from '@h2/common/components/hooks/useNavigator'

const ProfessionalDevelopmentImage = styled.img`
  max-width: 30%;
`
const ProfessionalDevelopment = ({ task }) => {
  const { systemName } = dynamicValues
  const [success, setSuccess] = useState(false)
  const [wasError, setWasError] = useState(false)
  const navigator = useNavigator()
  const { mutate, isLoading } = useMutation(
    () =>
      api.fetch('/plans/request/sequence/headed2PD', {
        method: 'POST',
        version: 'v1',
        body: JSON.stringify({})
      }),
    {
      onSuccess: resp => {
        setWasError(false)
        setSuccess(true)
        navigator(`/planning/assignments/detail/${resp.id}`)
      },
      onError: () => {
        setWasError(true)
      }
    }
  )

  return (
    <Flex gap="20px">
      <ProfessionalDevelopmentImage src="/images/headed2/new/cards/prof_dev_graphic.svg" />
      <div>
        <Text>{t`Did you know you have access to our free Level I professional development course in the ${systemName}? In this in-depth tutorial, we’ll review the basics of using the ${systemName} and get you up and running.`}</Text>
        <Text>{t`The development is delivered in four parts, including pre and post evaluations. However, no part needs to be done all at once, so you can complete it at your own pace.`}</Text>
        {success ? (
          <Alert
            align="center"
            message={t`Professional Development Assigned Successfully`}
            type="success"
          />
        ) : (
          <>
            <Alert
              isDismissible
              isVisible={wasError}
              message={t`An error occurred while trying to assign the Professional Development, please try again`}
              type="warning"
            />

            {task.completed && task.continueUrl ? (
              <Link size="large" href={task.continueUrl} variant="button">
                {t`Continue`}
              </Link>
            ) : (
              <Button size="large" onClick={mutate} isLoading={isLoading}>
                {t`Get Started`}
              </Button>
            )}
          </>
        )}
      </div>
    </Flex>
  )
}

export { ProfessionalDevelopment }
